import Flickity from "flickity";

require("flickity-sync");
require("flickity-as-nav-for");
require("flickity-imagesloaded");

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            autoPlay: false,
            contain: true,
            wrapAround: true,
            draggable: true,
            cellAlign: 'left',
            imagesLoaded: true
        });

        window.onresize = function(event) {
            flkty.resize();
            self.elem.querySelector('.flickity-viewport').style.height = 'inherit';
        };
    }
}

export default Carousel;
